export const BASE_IMAGE_BW =
  "https://res.cloudinary.com/marik-shnitman/image/upload/e_grayscale/w_1080,f_auto,dpr_auto,q_auto/v1547932540/";
export const BASE_IMAGE =
  "https://res.cloudinary.com/marik-shnitman/image/upload/w_1080,f_auto,dpr_auto,q_auto/v1547932540/";
export const BASE_IMAGE_ICON =
  "https://res.cloudinary.com/marik-shnitman/image/upload/w_300,f_auto,dpr_auto,q_auto/v1547932540/";
export const BASE_IMAGE_AVATAR =
  "https://res.cloudinary.com/marik-shnitman/image/upload/w_70,f_auto,dpr_auto,q_auto/v1547932540/";
  export const DEFAULT_PLAYER_IMAGE = process.env.SITE_OPEN_GRAPH_IMAGE ?? '';
  export const SITE_OPEN_GRAPH_IMAGE = process.env.SITE_OPEN_GRAPH_IMAGE ?? '';